import { IUploadingFile } from './FileUploader';
import { NoteAttachment } from './NoteAttachment';
import { createUseStyles } from 'react-jss';
import { DeleteAttachment } from './DeleteAttachment';
import { useEffect, useRef, useState } from 'react';
import { usePrevious } from '../support/hooks/usePrevious';
import { IAttachment } from './NotesClient';

const useStyles = createUseStyles({
    list: {
        gap: 10,
        marginLeft: 5,
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden'
    }
});

interface IAttachmentListProps {
    attachments: IAttachment[];
    uploadingAttachments?: IUploadingFile[],
    onDelete?: (attachment: IAttachment) => void;
}

export const AttachmentList: React.FC<IAttachmentListProps> = ({
    attachments,
    uploadingAttachments,
    onDelete
}) => {
    const classes = useStyles();
    const listRef = useRef<HTMLDivElement>(null);

    const [uploadCount, setUploadCount] = useState(uploadingAttachments?.length);
    const prevUploadCount = usePrevious(uploadCount);

    const deleteAttachment = async (attachment: IAttachment) => {
        if (onDelete) {
            onDelete(attachment);
        }
    };

    useEffect(() => {
        setUploadCount(uploadingAttachments?.length);
    }, [uploadingAttachments?.length]);

    // if uploading or just did upload, scroll to the end of the list so the user can see it
    useEffect(() => {
        if (uploadingAttachments?.length || (!uploadingAttachments?.length && prevUploadCount)) {
            listRef.current?.scrollTo({left: listRef.current?.scrollWidth});
        }
    }, [listRef, uploadingAttachments, prevUploadCount, uploadCount]);

    if (!attachments.length) {
        return null;
    }

    return (
        <div ref={listRef} className={classes.list} data-type="attachment-list">
            {attachments.map(attachment => (
                <div key={attachment.url} style={{display: 'flex', flexDirection: 'column', marginBottom: onDelete ? 0 : 10}}>
                    <NoteAttachment {...attachment} />
                    {onDelete &&
                        <DeleteAttachment onDelete={() => deleteAttachment(attachment)} />
                    }
                </div>
            ))}

            {uploadingAttachments?.map((file, i) => (
                <NoteAttachment key={i} {...{url: '', ...file, isUploading: true}} />
            ))}
        </div>
    );
};
